export default {"src":"/_next/static/media/ice-hockey.ec6485bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};